{
    "10": {
        "code": 10,
        "name_en": "Bangkok",
        "name_th": "กรุงเทพมหานคร",
        "districts": [
            1001, 1002, 1003, 1004, 1005, 1006, 1007, 1008, 1009, 1010, 1011, 1012, 1013, 1014, 1015, 1016, 1017, 1018,
            1019, 1020, 1021, 1022, 1023, 1024, 1025, 1026, 1027, 1028, 1029, 1030, 1031, 1032, 1033, 1034, 1035, 1036,
            1037, 1038, 1039, 1040, 1041, 1042, 1043, 1044, 1045, 1046, 1047, 1048, 1049, 1050
        ]
    },
    "11": {
        "code": 11,
        "name_en": "Samut Prakan",
        "name_th": "สมุทรปราการ",
        "districts": [1101, 1102, 1103, 1104, 1105, 1106]
    },
    "12": {
        "code": 12,
        "name_en": "Nonthaburi",
        "name_th": "นนทบุรี",
        "districts": [1201, 1202, 1203, 1204, 1205, 1206]
    },
    "13": {
        "code": 13,
        "name_en": "Pathum Thani",
        "name_th": "ปทุมธานี",
        "districts": [1301, 1302, 1303, 1304, 1305, 1306, 1307]
    },
    "14": {
        "code": 14,
        "name_en": "Phra Nakhon Si Ayutthaya",
        "name_th": "พระนครศรีอยุธยา",
        "districts": [1401, 1402, 1403, 1404, 1405, 1406, 1407, 1408, 1409, 1410, 1411, 1412, 1413, 1414, 1415, 1416]
    },
    "15": {
        "code": 15,
        "name_en": "Ang Thong",
        "name_th": "อ่างทอง",
        "districts": [1501, 1502, 1503, 1504, 1505, 1506, 1507]
    },
    "16": {
        "code": 16,
        "name_en": "Loburi",
        "name_th": "ลพบุรี",
        "districts": [1601, 1602, 1603, 1604, 1605, 1606, 1607, 1608, 1609, 1610, 1611]
    },
    "17": {
        "code": 17,
        "name_en": "Sing Buri",
        "name_th": "สิงห์บุรี",
        "districts": [1701, 1702, 1703, 1704, 1705, 1706]
    },
    "18": {
        "code": 18,
        "name_en": "Chai Nat",
        "name_th": "ชัยนาท",
        "districts": [1801, 1802, 1803, 1804, 1805, 1806, 1807, 1808]
    },
    "19": {
        "code": 19,
        "name_en": "Saraburi",
        "name_th": "สระบุรี",
        "districts": [1901, 1902, 1903, 1904, 1905, 1906, 1907, 1908, 1909, 1910, 1911, 1912, 1913]
    },
    "20": {
        "code": 20,
        "name_en": "Chon Buri",
        "name_th": "ชลบุรี",
        "districts": [2001, 2002, 2003, 2004, 2005, 2006, 2007, 2008, 2009, 2010, 2011]
    },
    "21": {
        "code": 21,
        "name_en": "Rayong",
        "name_th": "ระยอง",
        "districts": [2101, 2102, 2103, 2104, 2105, 2106, 2107, 2108]
    },
    "22": {
        "code": 22,
        "name_en": "Chanthaburi",
        "name_th": "จันทบุรี",
        "districts": [2201, 2202, 2203, 2204, 2205, 2206, 2207, 2208, 2209, 2210]
    },
    "23": {
        "code": 23,
        "name_en": "Trat",
        "name_th": "ตราด",
        "districts": [2301, 2302, 2303, 2304, 2305, 2306, 2307]
    },
    "24": {
        "code": 24,
        "name_en": "Chachoengsao",
        "name_th": "ฉะเชิงเทรา",
        "districts": [2401, 2402, 2403, 2404, 2405, 2406, 2407, 2408, 2409, 2410, 2411]
    },
    "25": {
        "code": 25,
        "name_en": "Prachin Buri",
        "name_th": "ปราจีนบุรี",
        "districts": [2501, 2502, 2503, 2506, 2507, 2508, 2509]
    },
    "26": {
        "code": 26,
        "name_en": "Nakhon Nayok",
        "name_th": "นครนายก",
        "districts": [2601, 2602, 2603, 2604]
    },
    "27": {
        "code": 27,
        "name_en": "Sa Kaeo",
        "name_th": "สระแก้ว",
        "districts": [2701, 2702, 2703, 2704, 2705, 2706, 2707, 2708, 2709]
    },
    "30": {
        "code": 30,
        "name_en": "Nakhon Ratchasima",
        "name_th": "นครราชสีมา",
        "districts": [
            3001, 3002, 3003, 3004, 3005, 3006, 3007, 3008, 3009, 3010, 3011, 3012, 3013, 3014, 3015, 3016, 3017, 3018,
            3019, 3020, 3021, 3022, 3023, 3024, 3025, 3026, 3027, 3028, 3029, 3030, 3031, 3032
        ]
    },
    "31": {
        "code": 31,
        "name_en": "Buri Ram",
        "name_th": "บุรีรัมย์",
        "districts": [
            3101, 3102, 3103, 3104, 3105, 3106, 3107, 3108, 3109, 3110, 3111, 3112, 3113, 3114, 3115, 3116, 3117, 3118,
            3119, 3120, 3121, 3122, 3123
        ]
    },
    "32": {
        "code": 32,
        "name_en": "Surin",
        "name_th": "สุรินทร์",
        "districts": [
            3201, 3202, 3203, 3204, 3205, 3206, 3207, 3208, 3209, 3210, 3211, 3212, 3213, 3214, 3215, 3216, 3217
        ]
    },
    "33": {
        "code": 33,
        "name_en": "Si Sa Ket",
        "name_th": "ศรีสะเกษ",
        "districts": [
            3301, 3302, 3303, 3304, 3305, 3306, 3307, 3308, 3309, 3310, 3311, 3312, 3313, 3314, 3315, 3316, 3317, 3318,
            3319, 3320, 3321, 3322
        ]
    },
    "34": {
        "code": 34,
        "name_en": "Ubon Ratchathani",
        "name_th": "อุบลราชธานี",
        "districts": [
            3401, 3402, 3403, 3404, 3405, 3407, 3408, 3409, 3410, 3411, 3412, 3414, 3415, 3419, 3420, 3421, 3422, 3424,
            3425, 3426, 3429, 3430, 3431, 3432, 3433
        ]
    },
    "35": {
        "code": 35,
        "name_en": "Yasothon",
        "name_th": "ยโสธร",
        "districts": [3501, 3502, 3503, 3504, 3505, 3506, 3507, 3508, 3509]
    },
    "36": {
        "code": 36,
        "name_en": "Chaiyaphum",
        "name_th": "ชัยภูมิ",
        "districts": [3601, 3602, 3603, 3604, 3605, 3606, 3607, 3608, 3609, 3610, 3611, 3612, 3613, 3614, 3615, 3616]
    },
    "37": {
        "code": 37,
        "name_en": "Amnat Charoen",
        "name_th": "อำนาจเจริญ",
        "districts": [3701, 3702, 3703, 3704, 3705, 3706, 3707]
    },
    "38": {
        "code": 38,
        "name_en": "Bueng Kan",
        "name_th": "บึงกาฬ",
        "districts": [3801, 3802, 3803, 3804, 3805, 3806, 3807, 3808]
    },
    "39": {
        "code": 39,
        "name_en": "Nong Bua Lam Phu",
        "name_th": "หนองบัวลำภู",
        "districts": [3901, 3902, 3903, 3904, 3905, 3906]
    },
    "40": {
        "code": 40,
        "name_en": "Khon Kaen",
        "name_th": "ขอนแก่น",
        "districts": [
            4001, 4002, 4003, 4004, 4005, 4006, 4007, 4008, 4009, 4010, 4011, 4012, 4013, 4014, 4015, 4016, 4017, 4018,
            4019, 4020, 4021, 4022, 4023, 4024, 4025, 4029
        ]
    },
    "41": {
        "code": 41,
        "name_en": "Udon Thani",
        "name_th": "อุดรธานี",
        "districts": [
            4101, 4102, 4103, 4104, 4105, 4106, 4107, 4108, 4109, 4110, 4111, 4117, 4118, 4119, 4120, 4121, 4122, 4123,
            4124, 4125
        ]
    },
    "42": {
        "code": 42,
        "name_en": "Loei",
        "name_th": "เลย",
        "districts": [4201, 4202, 4203, 4204, 4205, 4206, 4207, 4208, 4209, 4210, 4211, 4212, 4213, 4214]
    },
    "43": {
        "code": 43,
        "name_en": "Nong Khai",
        "name_th": "หนองคาย",
        "districts": [4301, 4302, 4305, 4307, 4308, 4314, 4315, 4316, 4317]
    },
    "44": {
        "code": 44,
        "name_en": "Maha Sarakham",
        "name_th": "มหาสารคาม",
        "districts": [4401, 4402, 4403, 4404, 4405, 4406, 4407, 4408, 4409, 4410, 4411, 4412, 4413]
    },
    "45": {
        "code": 45,
        "name_en": "Roi Et",
        "name_th": "ร้อยเอ็ด",
        "districts": [
            4501, 4502, 4503, 4504, 4505, 4506, 4507, 4508, 4509, 4510, 4511, 4512, 4513, 4514, 4515, 4516, 4517, 4518,
            4519, 4520
        ]
    },
    "46": {
        "code": 46,
        "name_en": "Kalasin",
        "name_th": "กาฬสินธุ์",
        "districts": [
            4601, 4602, 4603, 4604, 4605, 4606, 4607, 4608, 4609, 4610, 4611, 4612, 4613, 4614, 4615, 4616, 4617, 4618
        ]
    },
    "47": {
        "code": 47,
        "name_en": "Sakon Nakhon",
        "name_th": "สกลนคร",
        "districts": [
            4701, 4702, 4703, 4704, 4705, 4706, 4707, 4708, 4709, 4710, 4711, 4712, 4713, 4714, 4715, 4716, 4717, 4718
        ]
    },
    "48": {
        "code": 48,
        "name_en": "Nakhon Phanom",
        "name_th": "นครพนม",
        "districts": [4801, 4802, 4803, 4804, 4805, 4806, 4807, 4808, 4809, 4810, 4811, 4812]
    },
    "49": {
        "code": 49,
        "name_en": "Mukdahan",
        "name_th": "มุกดาหาร",
        "districts": [4901, 4902, 4903, 4904, 4905, 4906, 4907]
    },
    "50": {
        "code": 50,
        "name_en": "Chiang Mai",
        "name_th": "เชียงใหม่",
        "districts": [
            5001, 5002, 5003, 5004, 5005, 5006, 5007, 5008, 5009, 5010, 5011, 5012, 5013, 5014, 5015, 5016, 5017, 5018,
            5019, 5020, 5021, 5022, 5023, 5024, 5025
        ]
    },
    "51": {
        "code": 51,
        "name_en": "Lamphun",
        "name_th": "ลำพูน",
        "districts": [5101, 5102, 5103, 5104, 5105, 5106, 5107, 5108]
    },
    "52": {
        "code": 52,
        "name_en": "Lampang",
        "name_th": "ลำปาง",
        "districts": [5201, 5202, 5203, 5204, 5205, 5206, 5207, 5208, 5209, 5210, 5211, 5212, 5213]
    },
    "53": {
        "code": 53,
        "name_en": "Uttaradit",
        "name_th": "อุตรดิตถ์",
        "districts": [5301, 5302, 5303, 5304, 5305, 5306, 5307, 5308, 5309]
    },
    "54": {
        "code": 54,
        "name_en": "Phrae",
        "name_th": "แพร่",
        "districts": [5401, 5402, 5403, 5404, 5405, 5406, 5407, 5408]
    },
    "55": {
        "code": 55,
        "name_en": "Nan",
        "name_th": "น่าน",
        "districts": [5501, 5502, 5503, 5504, 5505, 5506, 5507, 5508, 5509, 5510, 5511, 5512, 5513, 5514, 5515]
    },
    "56": {
        "code": 56,
        "name_en": "Phayao",
        "name_th": "พะเยา",
        "districts": [5601, 5602, 5603, 5604, 5605, 5606, 5607, 5608, 5609]
    },
    "57": {
        "code": 57,
        "name_en": "Chiang Rai",
        "name_th": "เชียงราย",
        "districts": [
            5701, 5702, 5703, 5704, 5705, 5706, 5707, 5708, 5709, 5710, 5711, 5712, 5713, 5714, 5715, 5716, 5717, 5718
        ]
    },
    "58": {
        "code": 58,
        "name_en": "Mae Hong Son",
        "name_th": "แม่ฮ่องสอน",
        "districts": [5801, 5802, 5803, 5804, 5805, 5806, 5807]
    },
    "60": {
        "code": 60,
        "name_en": "Nakhon Sawan",
        "name_th": "นครสวรรค์",
        "districts": [6001, 6002, 6003, 6004, 6005, 6006, 6007, 6008, 6009, 6010, 6011, 6012, 6013, 6014, 6015]
    },
    "61": {
        "code": 61,
        "name_en": "Uthai Thani",
        "name_th": "อุทัยธานี",
        "districts": [6101, 6102, 6103, 6104, 6105, 6106, 6107, 6108]
    },
    "62": {
        "code": 62,
        "name_en": "Kamphaeng Phet",
        "name_th": "กำแพงเพชร",
        "districts": [6201, 6202, 6203, 6204, 6205, 6206, 6207, 6208, 6209, 6210, 6211]
    },
    "63": {
        "code": 63,
        "name_en": "Tak",
        "name_th": "ตาก",
        "districts": [6301, 6302, 6303, 6304, 6305, 6306, 6307, 6308, 6309]
    },
    "64": {
        "code": 64,
        "name_en": "Sukhothai",
        "name_th": "สุโขทัย",
        "districts": [6401, 6402, 6403, 6404, 6405, 6406, 6407, 6408, 6409]
    },
    "65": {
        "code": 65,
        "name_en": "Phitsanulok",
        "name_th": "พิษณุโลก",
        "districts": [6501, 6502, 6503, 6504, 6505, 6506, 6507, 6508, 6509]
    },
    "66": {
        "code": 66,
        "name_en": "Phichit",
        "name_th": "พิจิตร",
        "districts": [6601, 6602, 6603, 6604, 6605, 6606, 6607, 6608, 6609, 6610, 6611, 6612]
    },
    "67": {
        "code": 67,
        "name_en": "Phetchabun",
        "name_th": "เพชรบูรณ์",
        "districts": [6701, 6702, 6703, 6704, 6705, 6706, 6707, 6708, 6709, 6710, 6711]
    },
    "70": {
        "code": 70,
        "name_en": "Ratchaburi",
        "name_th": "ราชบุรี",
        "districts": [7001, 7002, 7003, 7004, 7005, 7006, 7007, 7008, 7009, 7010]
    },
    "71": {
        "code": 71,
        "name_en": "Kanchanaburi",
        "name_th": "กาญจนบุรี",
        "districts": [7101, 7102, 7103, 7104, 7105, 7106, 7107, 7108, 7109, 7110, 7111, 7112, 7113]
    },
    "72": {
        "code": 72,
        "name_en": "Suphan Buri",
        "name_th": "สุพรรณบุรี",
        "districts": [7201, 7202, 7203, 7204, 7205, 7206, 7207, 7208, 7209, 7210]
    },
    "73": {
        "code": 73,
        "name_en": "Nakhon Pathom",
        "name_th": "นครปฐม",
        "districts": [7301, 7302, 7303, 7304, 7305, 7306, 7307]
    },
    "74": {
        "code": 74,
        "name_en": "Samut Sakhon",
        "name_th": "สมุทรสาคร",
        "districts": [7401, 7402, 7403]
    },
    "75": {
        "code": 75,
        "name_en": "Samut Songkhram",
        "name_th": "สมุทรสงคราม",
        "districts": [7501, 7502, 7503]
    },
    "76": {
        "code": 76,
        "name_en": "Phetchaburi",
        "name_th": "เพชรบุรี",
        "districts": [7601, 7602, 7603, 7604, 7605, 7606, 7607, 7608]
    },
    "77": {
        "code": 77,
        "name_en": "Prachuap Khiri Khan",
        "name_th": "ประจวบคีรีขันธ์",
        "districts": [7701, 7702, 7703, 7704, 7705, 7706, 7707, 7708]
    },
    "80": {
        "code": 80,
        "name_en": "Nakhon Si Thammarat",
        "name_th": "นครศรีธรรมราช",
        "districts": [
            8001, 8002, 8003, 8004, 8005, 8006, 8007, 8008, 8009, 8010, 8011, 8012, 8013, 8014, 8015, 8016, 8017, 8018,
            8019, 8020, 8021, 8022, 8023
        ]
    },
    "81": {
        "code": 81,
        "name_en": "Krabi",
        "name_th": "กระบี่",
        "districts": [8101, 8102, 8103, 8104, 8105, 8106, 8107, 8108]
    },
    "82": {
        "code": 82,
        "name_en": "Phangnga",
        "name_th": "พังงา",
        "districts": [8201, 8202, 8203, 8204, 8205, 8206, 8207, 8208]
    },
    "83": {
        "code": 83,
        "name_en": "Phuket",
        "name_th": "ภูเก็ต",
        "districts": [8301, 8302, 8303]
    },
    "84": {
        "code": 84,
        "name_en": "Surat Thani",
        "name_th": "สุราษฎร์ธานี",
        "districts": [
            8401, 8402, 8403, 8404, 8405, 8406, 8407, 8408, 8409, 8410, 8411, 8412, 8413, 8414, 8415, 8416, 8417, 8418,
            8419
        ]
    },
    "85": {
        "code": 85,
        "name_en": "Ranong",
        "name_th": "ระนอง",
        "districts": [8501, 8502, 8503, 8504, 8505]
    },
    "86": {
        "code": 86,
        "name_en": "Chumphon",
        "name_th": "ชุมพร",
        "districts": [8601, 8602, 8603, 8604, 8605, 8606, 8607, 8608]
    },
    "90": {
        "code": 90,
        "name_en": "Songkhla",
        "name_th": "สงขลา",
        "districts": [9001, 9002, 9003, 9004, 9005, 9006, 9007, 9008, 9009, 9010, 9011, 9012, 9013, 9014, 9015, 9016]
    },
    "91": {
        "code": 91,
        "name_en": "Satun",
        "name_th": "สตูล",
        "districts": [9101, 9102, 9103, 9104, 9105, 9106, 9107]
    },
    "92": {
        "code": 92,
        "name_en": "Trang",
        "name_th": "ตรัง",
        "districts": [9201, 9202, 9203, 9204, 9205, 9206, 9207, 9208, 9209, 9210]
    },
    "93": {
        "code": 93,
        "name_en": "Phatthalung",
        "name_th": "พัทลุง",
        "districts": [9301, 9302, 9303, 9304, 9305, 9306, 9307, 9308, 9309, 9310, 9311]
    },
    "94": {
        "code": 94,
        "name_en": "Pattani",
        "name_th": "ปัตตานี",
        "districts": [9401, 9402, 9403, 9404, 9405, 9406, 9407, 9408, 9409, 9410, 9411, 9412]
    },
    "95": {
        "code": 95,
        "name_en": "Yala",
        "name_th": "ยะลา",
        "districts": [9501, 9502, 9503, 9504, 9505, 9506, 9507, 9508]
    },
    "96": {
        "code": 96,
        "name_en": "Narathiwat",
        "name_th": "นราธิวาส",
        "districts": [9601, 9602, 9603, 9604, 9605, 9606, 9607, 9608, 9609, 9610, 9611, 9612, 9613]
    }
}
